<template>
	<div>
		<div class="page-navbar navbar-white">
			<div class="nav-center-wrapper">
				<img class="navbar-logo" :src="$logoSrc" alt="getREEF Logo" />
			</div>
			<div class="navbar-content desktop-center">
				<button
					class="button button-transparent user-menu-button"
					@click="openUserMenuModal"
				>
					<i class="sk-icon-bars-regular"></i>
				</button>
				<UserPicture @click.native="openUserMenuModal" :size="25" />
				<div v-if="!isMobile" class="navbar-title">
					{{ navbarTitle }}
				</div>
			</div>
		</div>
		<div class="navbar-spacer"></div>
		<UserMenuModal ref="userMenuModal" />
	</div>
</template>

<style scoped>
.navbar-title {
	font-size: 14px;
	font-weight: 600;
	color: var(--gR-base-80);
}

.page-navbar >>> .user-profile-picture {
	margin-right: 15px;
}
</style>

<script>
import navbarMixin from "@/mixins/navbar-mixin"
import UserMenuModal from "@/components/modals/UserMenuModal.vue"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import UserPicture from "@/components/common/UserPicture.vue"

export default {
	name: "ResidentialUserNavbar",
	mixins: [navbarMixin, mobileResponsivenessMixin],
	components: {
		UserMenuModal,
		UserPicture
	},
	props: {
		title: String
	},
	computed: {
		navbarTitle() {
			if (this.$route.meta.title) {
				return this.$route.meta.title
			} else if (this.title) {
				return this.title
			}
			return null
		}
	}
}
</script>